<template>
  <v-container fluid class="lighten-12 content">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="welcome">
        <v-card height="100%">
          <v-row>
            <v-col cols="4" lg="4" sm="4">
              <v-img
                class="img"
                src="@/assets/Gananms.png"
                height="150px"
                width="70%"
              ></v-img>
            </v-col>
            <v-col cols="8" lg="8" sm="8">
              <v-row>
                <h2>
                  Welcome
                  {{ welcomeName }}
                </h2></v-row
              >
              <v-row class="mt-4">
                <permission-control permissionName="Room Index">
                  <v-col
                    cols="6"
                    sm="3"
                    class="quick-link"
                    @click="$router.push('/reservation')"
                  >
                    <v-row>
                      <v-icon
                        color="white"
                        class="quick-link-icon blue lighten-2"
                        large
                        >mdi-home-circle</v-icon
                      >
                    </v-row>
                    <v-row>
                      <div class="d-flex justify-center quick-link-label">
                        Reservation
                      </div>
                    </v-row>
                  </v-col>
                </permission-control>
                <permission-control permissionName="Stocks Show">
                  <v-col
                    cols="6"
                    sm="3"
                    class="quick-link"
                    @click="$router.push('/stock')"
                  >
                    <v-row>
                      <v-icon
                        color="white"
                        class="quick-link-icon green lighten-2"
                        large
                        >mdi-database</v-icon
                      >
                    </v-row>
                    <v-row>
                      <div class="d-flex justify-center quick-link-label">
                        Stock
                      </div>
                    </v-row>
                  </v-col>
                </permission-control>
                <permission-control permissionName="Dish Index">
                  <v-col
                    cols="6"
                    sm="3"
                    class="quick-link"
                    @click="$router.push('/suspended_bills')"
                  >
                    <v-row>
                      <v-icon
                        color="white"
                        class="quick-link-icon orange lighten-2"
                        large
                        >mdi-file-document</v-icon
                      >
                    </v-row>
                    <v-row>
                      <div class="d-flex justify-center quick-link-label">
                        Order
                      </div>
                    </v-row>
                  </v-col>
                </permission-control>
                <permission-control permissionName="Supplier Index">
                  <v-col
                    cols="6"
                    sm="3"
                    class="quick-link"
                    @click="$router.push('/supplier')"
                  >
                    <v-row>
                      <v-icon
                        color="white"
                        class="quick-link-icon purple lighten-2"
                        large
                        >mdi-account-multiple-outline</v-icon
                      >
                    </v-row>
                    <v-row>
                      <div class="d-flex justify-center quick-link-label">
                        Supplier
                      </div>
                    </v-row>
                  </v-col>
                </permission-control>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-10 justify-content-end container--fluid">
      <v-col cols="12" sm="12" md="6" lg="4">
        <v-btn-toggle
          v-model="summaryRange"
          @change="getDashboardSummary()"
          shaped
          mandatory
          dense
          background-color="grey"
        >
          <v-btn>
            <span style="font-size:12px">Today</span>
          </v-btn>

          <v-btn>
            <span style="font-size:12px">Last 7 days</span>
          </v-btn>

          <v-btn>
            <span style="font-size:12px">This month</span>
          </v-btn>

          <v-btn>
            <span style="font-size:12px">This year</span>
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <div>
      <v-row>
        <permission-control permissionName="Dashboard Order">
          <v-col cols="12" sm="12" md="4" lg="3">
            <div class="card">
              <div class="card-body">
                <div class="dash-widget-header row">
                  <div class="column">
                    <span class="dash-widget-icon text-danger border-danger">
                      <v-icon class="fe fefood"> mdi-food</v-icon>
                    </span>
                  </div>

                  <div class="column pl-4">Total</div>
                  <div class="amount  row pl-4 mb-5">
                    {{ dashBoardSummary.total_order_amount | formatCurrency }}
                  </div>
                </div>
                <div class="dash-widget-info">
                  <div class="column ml-4 pb-3">
                    <v-chip class="ma-0" color="blue" label outlined>
                      {{ dashBoardSummary.total_order_count }}

                      {{
                        dashBoardSummary.total_order_count > 1
                          ? "Orders"
                          : "Order"
                      }}
                    </v-chip>
                  </div>
                  <div class="progress progress-sm">
                    <div class="progress-bar bg-danger w-50"></div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </permission-control>
        <permission-control permissionName="Dashboard Reservation">
          <v-col cols="12" sm="12" md="4" lg="3">
            <div class="card">
              <div class="card-body">
                <div class="dash-widget-header row">
                  <div class="column">
                    <span class="dash-widget-icon text-primary border-primary">
                      <v-icon class="fe fecount"> mdi-home</v-icon>
                    </span>
                  </div>

                  <div class="column ml-4 ">Total</div>
                  <div class="amount column mb-5">
                    {{
                      dashBoardSummary.total_reservatio_amount | formatCurrency
                    }}
                  </div>
                </div>
                <div class="dash-widget-info">
                  <div class="column ml-4 pb-3 ">
                    <v-chip class="ma-0" color="blue" label outlined>
                      {{ dashBoardSummary.total_reservation_coun }}

                      {{
                        dashBoardSummary.total_reservation_coun > 1
                          ? "Reservations"
                          : "Reservation"
                      }}
                    </v-chip>
                  </div>
                  <div class="progress progress-sm">
                    <div class="progress-bar bg-primary w-50"></div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </permission-control>
        <permission-control permissionName="Dashboard  Expense">
          <v-col cols="12" sm="12" md="4" lg="3">
            <div class="card">
              <div class="card-body">
                <div class="dash-widget-header row">
                  <div class="column">
                    <span class="dash-widget-icon text-primary border-primary">
                      <v-icon class="fe fecount"> mdi-rocket</v-icon>
                    </span>
                  </div>

                  <div class="column ml-4">Total</div>
                  <div class="amount column mb-5">
                    {{ dashBoardSummary.expense_amount | formatCurrency }}
                  </div>
                </div>
                <div class="dash-widget-info">
                  <div class="row pb-3 ml-4">
                    <v-chip class="ma-0" color="blue" label outlined>
                      {{ dashBoardSummary.expense_count }}

                      {{
                        dashBoardSummary.expense_count > 1
                          ? "Expenses"
                          : "Expense"
                      }}
                    </v-chip>
                  </div>
                  <div class="progress progress-sm">
                    <div class="progress-bar bg-primary w-50"></div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </permission-control>
      </v-row>
      <v-row> </v-row>
    </div>

    <div>
      <div class="row">
        <div class="col-md-6 d-flex">
          <!-- Top Customer Foods -->
          <div class="card card-table flex-fill">
            <div class="card-header">
              <h2 class="card-title headertit">Top Guest Foods</h2>
            </div>
            <v-data-table
              :fixed-header="true"
              :headers="headers"
              :items="TopCustomers"
              item-key="id"
              hide-default-footer
            >
            </v-data-table>
          </div>
        </div>
        <div class="col-md-6 d-flex">
          <!-- Top Customer Reservation -->
          <div class="card card-table flex-fill">
            <div class="card-header">
              <h2 class="card-title headertit">Top Guest Reservations</h2>
            </div>
            <v-data-table
              :fixed-header="true"
              :headers="headers"
              :items="TopReservationCustomers"
              item-key="id"
              hide-default-footer
            >
            </v-data-table>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-md-6 d-flex">
          <!-- Top Customer Foods -->
          <div class="card card-table flex-fill">
            <div class="card-header">
              <h2 class="card-title headertit">Top Ordered Dish</h2>
            </div>
            <TopTrendingDish />
          </div>
        </div>
        <div class="col-md-6 d-flex">
          <!-- Top Customer Reservation -->
          <div class="card card-table flex-fill">
            <div class="card-header">
              <h2 class="card-title headertit">Top Ordered Product</h2>
            </div>
            <TopOrderProduct />
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-md-6 d-flex">
          <!-- Top Customer Foods -->
          <div class="card card-table flex-fill">
            <div class="card-header">
              <h2 class="card-title headertit">Table Orders</h2>
            </div>
            <TableOrders />
          </div>
        </div>
        <div class="col-md-6 d-flex">
          <!-- Top Customer Reservation -->
          <div class="card card-table flex-fill">
            <div class="card-header">
              <h2 class="card-title headertit">Waiter Orders</h2>
            </div>
            <WaiterOrders />
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-md-6 d-flex">
          <!-- Top Customer Foods -->
          <div class="card card-table flex-fill">
            <div class="card-header">
              <h2 class="card-title headertit">Order Type By Count</h2>
            </div>
            <OrderTypePieChart type="count" />
          </div>
        </div>

        <div class="col-md-6 d-flex">
          <!-- Top Customer Foods -->
          <div class="card card-table flex-fill">
            <div class="card-header">
              <h2 class="card-title headertit">Order Type By Amount</h2>
            </div>
            <OrderTypePieChart type="amount" />
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
// Charts
import LineChart from "@/components/Charts/LineChart";
import ColumnChart from "@/components/Charts/ColumnChart";
import DateRangeFilter from "@/components/base/DateRangeFilter";
import CategoryPieChart from "./CategoryPieChart";
import OrderTypePieChart from "./OrderTypePieChart";
import TopOrderProduct from "./TopOrderProduct";
import TopTrendingDish from "./TopTrendingDish";
import TableOrders from "./TableOrders";
import WaiterOrders from "./WaiterOrders";

import { mapState } from "vuex";
import axios from "@/plugins/axios";

export default {
  name: "Home",

  data: () => ({
    columns: [
      {
        text: "Name",
        value: "guest.name",
        show: true,
        disabled: true,
        width: "14%",
      },
      {
        text: "Phone",
        value: "guest.phone",
        align: "left",
        show: true,
        disabled: true,
        width: "14%",
      },
      {
        text: "Total Sales",
        value: "guest.total_sales",
        show: true,
        align: "left",
        disabled: false,
        width: "14%",
      },
      {
        text: "Paid Amount",
        value: "paid_amount",
        show: true,
        align: "left",
        disabled: false,
        width: "14%",
      },
    ],
    TopCustomers: [],
    items: [
      { title: "Today" },
      { title: "Last 7 Days" },
      { title: "This Month" },
      { title: "This Year" },
    ],
    dashBoardSummary: {},
    summaryRange: 0,
    selectedPeriod: "Today",
    noOfCustomers: 0,
    TopReservationCustomers: [],
  }),
  computed: {
    ...mapState("user", ["user"]),
    ...mapState(["theme"]),
    welcomeName() {
      const user = this.user || {};
      return user.username || "";
    },
    headers: function() {
      return this.columns.filter((item) => item.show == true);
    },
  },
  components: {
    LineChart,
    ColumnChart,
    DateRangeFilter,
    CategoryPieChart,
    OrderTypePieChart,
    TopOrderProduct,
    TopTrendingDish,
    TableOrders,
    WaiterOrders,
  },
  methods: {
    getTopOrderCustomer() {
      axios
        .get(`hms/dash-board/top-customer?type=order&range=${this.getRange()}`)
        .then((resp) => {
          this.TopCustomers = resp.data.data;
        })
        .catch((err) => {
          reject(err.response);
        });
    },
    getTopRecervationCustomer() {
      axios
        .get(
          `hms/dash-board/top-customer?type=reservation&range=${this.getRange()}`
        )
        .then((resp) => {
          this.TopReservationCustomers = resp.data.data;
        })
        .catch((err) => {
          reject(err.response);
        });
    },

    getDashboardSummary() {
      axios
        .get(`hms/dash-board/summary?range=${this.getRange()}`)
        .then((resp) => {
          this.dashBoardSummary = resp.data.data;
        })
        .catch((err) => {
          reject(err.response);
        });
      this.getTopOrderCustomer();
      this.getTopRecervationCustomer();
    },
    getRange() {
      if (this.summaryRange == 0) {
        return "today";
      } else if (this.summaryRange == 1) {
        return "last7Days";
      } else if (this.summaryRange == 2) {
        return "thisMonth";
      } else if (this.summaryRange == 3) {
        return "thisYear";
      }
    },
    selectItem(item) {
      this.selectedPeriod = item.title;
    },
    getRangeText() {
      if (this.summaryRange == 0) {
        return "Today";
      } else if (this.summaryRange == 1) {
        return "Last 7 Days";
      } else if (this.summaryRange == 2) {
        return "This Month";
      } else if (this.summaryRange == 3) {
        return "This Year";
      }
    },
    getCustomerPercentage(total, active) {
      let result = (active / total) * 100;
      if (result % 1 == 0) {
        return result;
      } else {
        return result.toFixed(2);
      }
    },
  },
  created() {
    this.getDashboardSummary();
    this.getTopOrderCustomer();
  },
};
</script>
<style scoped>
.img {
 border-radius: 6px;
}

.card-body {
  padding: 1.5rem;
}

.card-body {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1.25rem;
}

.card {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

body {
  background-color: #f8f9fa;
  color: #333;
  font-family: "Mada", sans-serif;
  font-size: 1rem;
  height: 100%;
  line-height: 1.5;
  overflow-x: hidden;
}
.dash-widget-header {
  align-items: center;
  display: flex;
  margin-bottom: 15px;
}
.dash-widget-icon {
  align-items: center;
  display: inline-flex;
  font-size: 1.875rem;
  height: 50px;
  justify-content: center;
  line-height: 48px;
  text-align: center;
  width: 50px;
  border: 3px solid;
  border-radius: 50px;
  padding: 28px;
}
.border-danger {
  border-color: #dc3545 !important;
}
.dash-count {
  font-size: 18px;
  margin-left: auto;
}
.text-muted {
  color: #757575 !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Mada", sans-serif;
  margin-top: 0;
}

.h6,
h6 {
  font-size: 1rem;
}
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}
h6 {
  display: block;
  font-size: 0.67em;
  margin-block-start: 2.33em;
  margin-block-end: 2.33em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}
.progress.progress-sm {
  height: 6px;
}

.progress {
  display: -ms-flexbox;
  display: flex;
  height: 1rem;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}
.w-50 {
  width: 50% !important;
}
.bg-danger,
.badge-danger {
  background-color: #e84646 !important;
}
.progress-bar {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-pack: center;
  justify-content: center;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #007bff;
  transition: width 0.6s ease;
}

h6 {
  font-size: 1rem;
}
h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

.fe {
  display: inline-block;
  font: normal normal normal 16px feathericon;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}
.text-danger {
  color: #e84646 !important;
}

.border-primary {
  border-color: #00d0f1 !important;
}

.text-primary {
  color: #00d0f1 !important;
}
.bg-primary {
  background-color: #00d0f1 !important;
}

.text-success {
  color: #699834 !important;
}

.bg-success {
  background-color: #28a745 !important;
}
.text-warning {
  color: #ffc107 !important;
}
.border-warning {
  border-color: #ffc107 !important;
}

.bg-warning {
  background-color: #ffc107 !important;
}

.fefood {
  color: #dc3545;
}
.fecash {
  color: #ffc107 !important;
}

.feaccount {
  color: #28a745 !important;
}

.fecount {
  color: #00d0f1 !important;
}

.card {
  border: 1px solid #f0f0f0;
  margin-bottom: 1.875rem;
}
flex-fill {
  -ms-flex: 1 1 auto !important;
  flex: 1 1 auto !important;
}

.card {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.card .card-header {
  background-color: #fff;
  border-bottom: 1px solid #eaeaea;
}

.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-header {
  border-bottom: 1px solid #e6e6e6;
  padding: 1rem 1.5rem;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.card .card-header .card-title {
  margin-bottom: 0;
}
.card-title {
  margin-bottom: 0.75rem;
}
.h4 {
  font-family: "Mada", sans-serif;
  margin-top: 0;
}
.h4 {
  font-size: 1.5rem;
}

.h4 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

.h4 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}
.h4 {
  display: block;
  margin-block-start: 1.33em;
  margin-block-end: 1.33em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}

.card-table .card-body {
  padding: 0;
}
.card-body {
  padding: 1.5rem;
}

.card-body {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1.25rem;
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive {
  white-space: nowrap;
}

.table {
  color: #333;
  max-width: 100%;
  margin-bottom: 0;
  width: 100%;
}
.mb-0 {
  margin-bottom: 0 !important;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}

table {
  border-collapse: collapse;
}
table {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  text-indent: initial;
  border-spacing: 2px;
  border-color: grey;
}
.table-responsive {
  white-space: nowrap;
}

.table thead {
  background-color: #f8f9fa;
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);
}

thead {
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
}

.table {
  color: #333;
  max-width: 100%;
  margin-bottom: 0;
  width: 100%;
}
table {
  border-collapse: collapse;
}
table {
  border-collapse: separate;
  text-indent: initial;
  border-spacing: 2px;
}

tr {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}

.card-table .card-body .table tr th:first-child {
  padding-left: 1.5rem;
}
.card-table .card-body .table > thead > tr > th {
  border-top: 0;
}
.card-table .table th {
  border-top: 1px solid #e2e5e8;
  padding: 1rem 0.75rem;
  white-space: nowrap;
}
.table.table-center th {
  vertical-align: middle;
}
.table thead tr th {
  font-weight: 600;
  border: 0;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
th {
  text-align: inherit;
}
th {
  display: table-cell;
  vertical-align: inherit;
  font-weight: bold;
  text-align: -internal-center;
}
card-table .table th {
  border-top: 1px solid #e2e5e8;
  padding: 1rem 0.75rem;
  white-space: nowrap;
}
.table.table-center th {
  vertical-align: middle;
}
.table thead tr th {
  font-weight: 600;
  border: 0;
}
.table tbody tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.welcome {
  margin-bottom: -52px;
}
.quick-link {
  cursor: pointer;
}
tr {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}

.card-table .card-body .table tr th:first-child {
  padding-left: 1.5rem;
}
.card-table .table td {
  border-top: 1px solid #e2e5e8;
  padding: 1rem 0.75rem;
  white-space: nowrap;
}

.table.table-center td {
  vertical-align: middle;
}

.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
td {
  display: table-cell;
  vertical-align: inherit;
}

table.table td h2.table-avatar {
  align-items: center;
  display: inline-flex;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  white-space: nowrap;
}

. table.table td h2 {
  display: inline-block;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
  vertical-align: middle;
}

h2 {
  font-family: "Mada", sans-serif;
  margin-top: 0;
}

.h2 {
  font-size: 2rem;
}

.h2 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h2 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

.text-warning {
  color: #ffbc34 !important;
}

.fe {
  display: inline-block;
  font: normal normal normal 16px feathericon;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.text-warning {
  color: #ffc107 !important;
}

.avatar > img {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}
.rounded-circle {
  border-radius: 50% !important;
}

img {
  vertical-align: middle;
  border-style: none;
}

table.table td h2 a {
  color: #333;
}

a {
  color: #0dd9f9;
}
a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
}
.table tbody tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.card-table .table td {
  border-top: 1px solid #e2e5e8;
  padding: 1rem 0.75rem;
  white-space: nowrap;
}

table.table td h2 a {
  color: #333;
}
table.table td h2.table-avatar {
  align-items: center;
  display: inline-flex;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  white-space: nowrap;
}

table.table td h2 {
  display: inline-block;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
  vertical-align: middle;
}
tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}

.avatar > img {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}

img {
  vertical-align: middle;
  border-style: none;
}

table.table td h2 a {
  color: #333;
}

.avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
}
.avatar {
  position: relative;
  display: inline-block;
  width: 3rem;
  height: 3rem;
}
.mr-2 {
  margin-right: 0.5rem !important;
}

a {
  transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  -webkit-transition: all 0.4s ease;
}

table.table td h2.table-avatar {
  align-items: center;
  display: inline-flex;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  white-space: nowrap;
}

table.table td h2 {
  display: inline-block;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
  vertical-align: middle;
}
h2 {
  font-size: 1.5em;
  font-weight: bold;
}
table.table td h2.table-avatar {
  align-items: center;
  display: inline-flex;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  white-space: nowrap;
}

table.table td h2 {
  display: inline-block;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
  vertical-align: middle;
}

.table tbody tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.card-table .table td {
  border-top: 1px solid #e2e5e8;
  padding: 1rem 0.75rem;
  white-space: nowrap;
}
.bgcolor {
  background-color: white !important;
  height: 60px !important;
}

.headertit {
  font-weight: 600 !important;
}

.headtit {
  height: 130px;
  margin-bottom: 45px !important;
}
.animatedSvg {
  background-image: url(http://localhost:8092/img/user.c4b2e70b.svg);
  background-position: center center;
  background-size: cover;
  width: 320px;
  height: 120px;
}
</style>
